import React from 'react';
import PastBlastList from './PastBlastList';

function SmsBlast() {
    return (
        <PastBlastList
            title="Past SMS Blast"
            description="Track SMS blasts from queueing through send completion."
            icon="bi-chat-dots"
            type="SMS"
            createPath="/blast/create-sms"
            createLabel="Create SMS Blast"
            resultsBasePath="/blast/sms"
            emptyTitle="No SMS blasts yet"
            emptyDescription="Create an SMS blast to message selected patients. Past launches will show here with status."
            infoText="Only patients with a cell number who have not opted out of SMS are eligible. Large blasts queue in the background and show as In progress until ready. While Pending, you can Stop a blast before it sends. Use Results after a blast completes or errors."
        />
    );
}

export default SmsBlast;
